import { Alert, Heading, Paragraph } from "@digdir/designsystemet-react";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { httpClient } from "@/api/client";
import { getAvtaleSelskapOptions } from "@/api/generated/@tanstack/react-query.gen";
import { Page } from "@/components";
import { formatDateString } from "@/utils";
import { EndreAvtaleFormSkeleton } from "./components/endre/EndreAvtaleFormSkeleton";
import { EndreSelskapAvtaleForm } from "./components/endre/EndreSelskapAvtaleForm";

export const EndreSelskapsAvtalePage = () => {
  const { t } = useTranslation();
  const params = useParams({
    from: "/_app/avtaler/$avtalerId/selskap/endre/",
  });

  const {
    data: selskapsAvtale,
    isLoading: isLoadingSelskapsAvtale,
    isError: isErrorSelskapsAvtale,
    dataUpdatedAt,
  } = useQuery({
    ...getAvtaleSelskapOptions({
      client: httpClient,
      path: {
        id: params.avtalerId,
      },
    }),
  });

  return (
    <Page withBackLink>
      <Heading>{t("pages.endre.tittel")}</Heading>
      <Paragraph>
        {t("pages.endre.beskrivesle", {
          context: formatDateString(selskapsAvtale?.avtale.avbestillingsFrist),
        })}
      </Paragraph>
      {isLoadingSelskapsAvtale ? (
        <EndreAvtaleFormSkeleton />
      ) : isErrorSelskapsAvtale === true || selskapsAvtale?.avtale == null ? (
        <Alert data-color={"danger"}>
          {t("pages.endre.form.feil.feil-lasting")}
        </Alert>
      ) : selskapsAvtale.avtale.avtaleStatus !== "Aktiv" ? (
        <div className="flex flex-col my-8">
          <Alert>
            {t("pages.avtaler.statuser.avtaleStatus", {
              context: selskapsAvtale.avtale.avtaleStatus,
            })}
          </Alert>
        </div>
      ) : (
        // Key forces remount when data is refetched
        // This is a workaround for stale state issues with useSelskapsBoligType
        // See useSelskapsBoligType for more details
        <EndreSelskapAvtaleForm avtale={selskapsAvtale} key={dataUpdatedAt} />
      )}
    </Page>
  );
};
